import { useContext as useReactContext } from 'react';
import { context } from '../context';

export const useContext = () => useReactContext(context);
